import { apiGet, apiPatch } from './client';
import type { IndustryGroup, IndustryGroupBatchRequest } from '../types/IndustryGroup';

export function getIndustryGroups(): Promise<IndustryGroup[]> { return apiGet<IndustryGroup[]>('/api/industry-groups'); }

export function saveBatchIndustryGroups(added: IndustryGroup[], modified: IndustryGroup[], deletedIds: number[]): Promise<IndustryGroup[]> {
  return apiPatch<IndustryGroupBatchRequest, IndustryGroup[]>('/api/industry-groups/batch', { added, modified, deleted: deletedIds });
}
